<div class="row" *ngIf="modelList.length > 0;else noDocument">

    <div class="w-100 p-2">
        <div class="card rapporti-card p-0" style="min-height: 550px;">
            <div class="header-zona">
                <span class="titolo-card-doc">Altri documenti</span>
            </div>
            <div class="card-body rapporti-doc" style="min-height: 50px;">
                <div class="row">
                    <div class="col-xxxl-12 col-md-12" *ngFor="let header of modelList;">
                        <ul>
                            <li *ngFor="let element of header.elements;">
                                <a href="{{ websiteUrl }}{{ element.url }}"
                                    onclick="window.open(this.href + '#&navpanes=0&scrollbar=0&view=FitH', 'Altro','left=20,top=20,width=800,height=700,resizable=1'); return false;"
                                    class="colored">{{element.descrizione}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #noDocument>
    <div class="row">
        <div class="p-2 w-100">
          <div class="card rapporti-card p-0" style="min-height: 550px;">
            <div class="header-zona">
              <span class="titolo-card-doc">Altro</span>
            </div>
            <div class="card-body rapporti-doc" style="min-height: 50px;">
              <div class="col-xxxl-12 col-md-12" >Nessun contenuto recuperato per questa sezione
              </div>
            </div>
          </div>
        </div>
      </div>
</ng-template>